<template>
  <div class="customer-details">
    <h4>Information Details</h4>
    <div class="customer-info">
      <p><strong>Name: {{user.first_name}} {{user.last_name}}</strong></p>
      <p><strong>Email: {{user.email}}</strong></p>
      <p><strong>Country: {{user.country}}</strong></p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters.StateUser.data;
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.customer-details {
  max-width: 60rem;
  margin: 2rem auto;
  padding: 2rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: left;
}
.customer-details h4 {
  margin-bottom: 1.5rem;
  text-align: left;
  font-size: 1.1rem;
  font-family: 'GothicB';
}
.customer-info {
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}
.customer-info strong {
  font-weight: 800;
  font-family: 'GothicB';
}
.customer-info ul {
  margin: 0.5rem 0 1rem 1.2rem;
  padding-left: 0;
  list-style-type: disc;
}
</style>
